export type LiveTranscriptionAvailabilityPayload = {
	available: boolean;
};

export type LiveTranscriptionAvailabilityFetchedAction = {
	type: 'LIVE_TRANSCRIPTION_AVAILABILITY_FETCHED';
	payload: LiveTranscriptionAvailabilityPayload;
};

export default (
	payload: LiveTranscriptionAvailabilityPayload,
): LiveTranscriptionAvailabilityFetchedAction => ({
	type: 'LIVE_TRANSCRIPTION_AVAILABILITY_FETCHED',
	payload,
});
